module.exports = __webpack_public_path__ + "img/35.bf170774.jpg";